export const BASE = 'auth';
export const LOGIN = `${BASE}-login`;
export const ACTIVATION = `${BASE}-confirm`;
export const RESET_PASSWORD = `${BASE}-reset-password`;
